class SmoothScroll {
  constructor() {
    this.init();
  }

  init() {
    // Attendre que le DOM soit chargé
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupSmoothScroll());
    } else {
      this.setupSmoothScroll();
    }
  }

  setupSmoothScroll() {
    // Sélectionner tous les liens qui commencent par # et qui sont sur la même page
    const internalLinks = document.querySelectorAll('a[href^="#"]');
    
    internalLinks.forEach(link => {
      // Vérifier que le lien ne contient pas de chemin (juste une ancre)
      const href = link.getAttribute('href');
      if (href && href.indexOf('/') === -1 && href.indexOf('?') === -1) {
        // Exclure les liens des pages de compte client (formulaires avec erreurs)
        const isCustomerPage = link.closest('.customer');
        // Exclure les liens d'accessibilité (skip to content)
        const isSkipLink = link.classList.contains('skip-to-content-link');
        // Exclure les liens vers des champs de formulaire en erreur
        const isFormErrorLink = href.includes('Form-') || href.includes('ContactForm-') || href.includes('CommentForm-');
        
        if (!isCustomerPage && !isSkipLink && !isFormErrorLink) {
          link.addEventListener('click', (e) => this.handleInternalLink(e));
        }
      }
    });
  }

  handleInternalLink(e) {
    const href = e.currentTarget.getAttribute('href');
    
    // Ignorer les liens vides ou vers le haut de page
    if (href === '#' || href === '#top') {
      return;
    }

    // Vérifier si l'élément cible existe
    const targetElement = document.querySelector(href);
    if (!targetElement) {
      return;
    }

    // Empêcher le comportement par défaut
    e.preventDefault();

    // Calculer la position de l'élément cible
    const targetPosition = this.getTargetPosition(targetElement);
    
    // Effectuer le smooth scroll
    this.smoothScrollTo(targetPosition);
  }

  getTargetPosition(targetElement) {
    const headerHeight = this.getHeaderHeight();
    const targetRect = targetElement.getBoundingClientRect();
    const targetPosition = targetRect.top + window.pageYOffset - headerHeight - 20; // 20px de marge
    
    return Math.max(0, targetPosition); // Ne pas aller en dessous de 0
  }

  getHeaderHeight() {
    // Trouver la hauteur du header fixe s'il existe
    const header = document.querySelector('header');
    if (header) {
      const headerStyle = window.getComputedStyle(header);
      const position = headerStyle.getPropertyValue('position');
      
      if (position === 'fixed' || position === 'sticky') {
        return header.offsetHeight;
      }
    }
    
    return 0;
  }

  smoothScrollTo(targetPosition) {
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 800; // Durée en millisecondes
    let start = null;

    function animation(currentTime) {
      if (start === null) start = currentTime;
      const timeElapsed = currentTime - start;
      const run = this.easeInOutCubic(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      
      if (timeElapsed < duration) {
        requestAnimationFrame(animation.bind(this));
      }
    }

    requestAnimationFrame(animation.bind(this));
  }

  easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t * t + b;
    t -= 2;
    return c / 2 * (t * t * t + 2) + b;
  }
}

// Initialiser le smooth scroll
new SmoothScroll(); 